{
  "+Z5RUs": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Allmänna villkor"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder dessa allmänna villkor för veterinärtjänster enligt dess senaste lydelse."
    }
  ],
  "+itf/D": [
    {
      "type": 0,
      "value": "Save"
    }
  ],
  "/vhYnT": [
    {
      "type": 0,
      "value": "Notes for the clinic"
    }
  ],
  "03+aWo": [
    {
      "type": 0,
      "value": "Summary"
    }
  ],
  "1bZ2OG": [
    {
      "type": 0,
      "value": "Last visited"
    }
  ],
  "3QGdyf": [
    {
      "type": 0,
      "value": "Choose a clinic"
    }
  ],
  "3Wcqsy": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "3Ymbfk": [
    {
      "children": [
        {
          "type": 0,
          "value": "Mobil:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " please update your Mobil number below"
    }
  ],
  "4BH2f8": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "4QxoQn": [
    {
      "children": [
        {
          "type": 0,
          "value": "Allmänt"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Evidensia ska i den mån det är möjligt anteckna omfattningen av den Sjukvårdande behandlingen i journalen. Om Evidensia upptäcker efter Inskrivningen att det krävs någon annan omfattning av den Sjukvårdande behandlingen ska detta antecknas i journalen och Djurägaren ska så snart det kan ske informeras om detta. Vid akut eller livshotande tillstånd hos djuret behöver omfattningen av den Sjukvårdande behandlingen inte antecknas i journalen förrän efter att den Sjukvårdande behandlingen utförts. Evidensia har alltid rätt att, helt eller delvis och utan motivering, avböja att utföra Sjukvårdande behandling."
    }
  ],
  "7Vk55F": [
    {
      "type": 0,
      "value": "Address"
    }
  ],
  "7u0nhU": [
    {
      "type": 0,
      "value": "I have read and agree to "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "the general terms and conditions"
        }
      ],
      "type": 8,
      "value": "tclink"
    },
    {
      "type": 0,
      "value": " and read "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "the personal data policy"
        }
      ],
      "type": 8,
      "value": "pplink"
    }
  ],
  "8faccV": [
    {
      "type": 0,
      "value": "Show details"
    }
  ],
  "8isYGV": [
    {
      "type": 0,
      "value": "Continue"
    }
  ],
  "8pRmsV": [
    {
      "type": 0,
      "value": "Approval of General Terms for horses"
    }
  ],
  "8rOQmk": [
    {
      "type": 0,
      "value": "Male"
    }
  ],
  "95SGnw": [
    {
      "type": 0,
      "value": "Female"
    }
  ],
  "9ayVdY": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Inskrivning"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder det förfarande genom vilket Hästägaren/Beställaren registrerar sin häst hos Evidensia i anslutning till den Sjukvårdande behandlingen"
    }
  ],
  "9biY42": [
    {
      "type": 0,
      "value": "Thank you for your booking"
    }
  ],
  "9hKhyZ": [
    {
      "type": 0,
      "value": "Try Again"
    }
  ],
  "A4Bx7L": [
    {
      "children": [
        {
          "type": 0,
          "value": "Allmänt"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Evidensia ska i den mån det är möjligt anteckna omfattningen av den Sjukvårdande behandlingen i journalen. Om Evidensia upptäcker efter Inskrivningen att det krävs någon annan omfattning av den Sjukvårdande behandlingen ska detta antecknas i journalen och Beställaren ska så snart det kan ske informeras om detta. Vid akut eller livshotande tillstånd hos hästen behöver omfattningen av den Sjukvårdande behandlingen inte antecknas i journalen förrän efter att den Sjukvårdande behandlingen utförts. Evidensia har alltid rätt att, helt eller delvis och utan motivering, avböja att utföra Sjukvårdande behandling."
    }
  ],
  "AtemAW": [
    {
      "type": 0,
      "value": "Select service"
    }
  ],
  "BqUf8Z": [
    {
      "type": 0,
      "value": "Castrated:"
    }
  ],
  "Bs6GJB": [
    {
      "type": 0,
      "value": "Try Again!"
    }
  ],
  "C3dd3n": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "CFpmc1": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "CariJR": [
    {
      "type": 0,
      "value": "Retry"
    }
  ],
  "CyniKP": [
    {
      "type": 0,
      "value": "Terms accepted"
    }
  ],
  "D7qbEN": [
    {
      "type": 0,
      "value": "Test TOS consent screen"
    }
  ],
  "E3FP8J": [
    {
      "type": 0,
      "value": "My pets"
    }
  ],
  "EMGu+t": [
    {
      "type": 0,
      "value": "Could not accept the terms. Please try again or come back later."
    }
  ],
  "EpI0mc": [
    {
      "children": [
        {
          "type": 0,
          "value": "Besiktning"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Om den Sjukvårdande behandlingen utgörs av besiktning av hästens status, hälsa eller därmed jämförbart tillstånd ska Evidensia i samband med Inskrivningen anteckna syftet med besiktningen. Syftet kommer vara avgörande för nivån och omfattningen av besiktningen. Hästägaren/Beställaren är medveten om att en besiktning alltid utgör en ögonblicksbedömning och en subjektiv värdering."
    }
  ],
  "Exb2ky": [
    {
      "type": 0,
      "value": "Confirm the booking"
    }
  ],
  "ExmxoP": [
    {
      "children": [
        {
          "type": 0,
          "value": "Allmänt"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Evidensia ersätter Hästägaren/Beställaren endast för skada som orsakats av vårdslöshet eller försummelse vid utförandet av den Sjukvårdande behandlingen, dock inte indirekt skada. Evidensia ersätter inte förlust, skada eller utebliven vinst i näringsverksamhet. Ersättning enligt ovan betalas med ett högsta belopp om ett (1) prisbasbelopp (vid var tid gällande enligt socialförsäkringsbalken), om inte något annat anges i dessa Allmänna villkor eller i besiktningsintyget för häst."
    }
  ],
  "F0qtSP": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Djurägaren"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder en person som är minst 18 år och som äger eller har ansvar (som ombud för ägaren) för djuret som den Sjukvårdande behandlingen avser."
    }
  ],
  "FCesIR": [
    {
      "type": 0,
      "value": "Address"
    }
  ],
  "FbCJFI": [
    {
      "type": 0,
      "value": "Something went wrong"
    }
  ],
  "H3OeAm": [
    {
      "type": 0,
      "value": "My Pets"
    }
  ],
  "H4LWtl": [
    {
      "type": 0,
      "value": "My account"
    }
  ],
  "H8W9dk": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Sjukvårdande behandling"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder varje åtgärd som vidtas för att medicinskt förebygga, påvisa, lindra eller bota sjukdom, skada eller därmed jämförligt tillstånd hos djur; åtgärder för att utföra operativa ingrepp på eller ge injektioner till djur i annat fall; inklusive, men inte begränsat till, besiktningar av och utlåtanden om djurs status, hälsa eller därmed jämförbart tillstånd."
    }
  ],
  "HYP1NC": [
    {
      "type": 0,
      "value": "Something went wrong"
    }
  ],
  "HZxi+1": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Dotterbolag"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder ett bolag (i) som direkt eller indirekt kontrollerar Evidensia; (ii) som är under samma direkta eller indirekta ägande eller kontroll som Evidensia; eller (iii) som direkt eller indirekt ägs eller kontrolleras av Evidensia. I det här sammanhanget ska ett bolag anses vara kontrollerat av någon annan om det andra bolaget äger mer än femtio procent (>50%) av rösterna i ett sådant bolag, kan styra bolagets angelägenheter eller kontrollera styrelsens, eller motsvarande organs, sammansättning av styrelseledamöter eller motsvarande."
    }
  ],
  "IS8Z03": [
    {
      "type": 0,
      "value": "No"
    }
  ],
  "Ix5QgD": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Kostnadsförslag"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder en ungefärlig prisuppgift för den Sjukvårdande behandlingen som Evidensia lämnar till Hästägaren/Beställaren i samband med Inskrivningen."
    }
  ],
  "J2tn32": [
    {
      "type": 0,
      "value": "Sorry something went wrong, please try again later"
    }
  ],
  "Lj4b+u": [
    {
      "type": 0,
      "value": "Enter your e-mail address"
    }
  ],
  "Ly9eQD": [
    {
      "children": [
        {
          "type": 0,
          "value": "Address:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " please update your address details below"
    }
  ],
  "NmI5fB": [
    {
      "type": 0,
      "value": "Breed"
    }
  ],
  "OMbXig": [
    {
      "type": 0,
      "value": "Name"
    }
  ],
  "OTjx7h": [
    {
      "type": 0,
      "value": "Something went wrong"
    }
  ],
  "OZc0Dg": [
    {
      "type": 0,
      "value": "Select service"
    }
  ],
  "P4eWiS": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "Qlxw7J": [
    {
      "type": 0,
      "value": "Pet details"
    }
  ],
  "R2Y70i": [
    {
      "type": 0,
      "value": "Enter your mobile number"
    }
  ],
  "S2gCCL": [
    {
      "type": 0,
      "value": "Please indicate symptoms, wishes or anything else that is good for us to know, e.g. if the animal has visited us before with another animal owner."
    }
  ],
  "S6hFuf": [
    {
      "type": 0,
      "value": "Book clinic visit"
    }
  ],
  "SHAwNy": [
    {
      "type": 0,
      "value": "READ AND ACCEPT"
    }
  ],
  "SSnzcX": [
    {
      "children": [
        {
          "type": 0,
          "value": "Breed:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Search for and change the breed of your pet."
    }
  ],
  "SwYEPV": [
    {
      "type": 0,
      "value": "Gender"
    }
  ],
  "T4E2Fv": [
    {
      "type": 0,
      "value": "Try Again!"
    }
  ],
  "T8oNqb": [
    {
      "children": [
        {
          "type": 0,
          "value": "Insurance company:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Search for and change your insurance provider"
    }
  ],
  "TRDtyo": [
    {
      "type": 0,
      "value": "Login"
    }
  ],
  "ThaO7S": [
    {
      "type": 0,
      "value": "Yes"
    }
  ],
  "Uo14SK": [
    {
      "children": [
        {
          "type": 0,
          "value": "Allmänt"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Evidensia ersätter Djurägaren endast för skada som orsakats av vårdslöshet eller försummelse vid utförandet av den Sjukvårdande behandlingen, dock inte indirekt skada. Evidensia ersätter inte förlust, skada eller utebliven vinst i näringsverksamhet. Ersättning enligt ovan betalas med ett högsta belopp om ett (1) prisbasbelopp (vid var tid gällande enligt socialförsäkringsbalken), om inte något annat anges i dessa Allmänna villkor. Evidensia ersätter inte Djurägaren för skada till följd av att Djurägaren använder, eller förlitar sig på, ett besiktningsprotokoll för något annat syfte än det syfte som angavs i samband med Inskrivningen."
    }
  ],
  "VJHGax": [
    {
      "type": 0,
      "value": "Accepted"
    }
  ],
  "VNdtgp": [
    {
      "type": 0,
      "value": "months"
    }
  ],
  "VVYfZW": [
    {
      "type": 0,
      "value": "Mobile"
    }
  ],
  "VzXPY/": [
    {
      "type": 0,
      "value": "Mobile"
    }
  ],
  "WWEZX6": [
    {
      "type": 0,
      "value": "Try Again"
    }
  ],
  "WoIxoP": [
    {
      "type": 0,
      "value": "Date Of Birth"
    }
  ],
  "Wyk0Yt": [
    {
      "children": [
        {
          "type": 0,
          "value": "Profylaktisk behandling på initiativ av Hästägaren/Beställaren"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Evidensia ersätter inte skada till följd av profylaktisk behandling som utförts på initiativ av Hästägaren/Beställaren om Evidensia dessförinnan har avrått Hästägaren/ Beställaren från behandlingen."
    }
  ],
  "XDTgUs": [
    {
      "type": 0,
      "value": "Try Again"
    }
  ],
  "XVF6up": [
    {
      "type": 0,
      "value": "Insurance number"
    }
  ],
  "Xl2OHD": [
    {
      "type": 0,
      "value": "Logout"
    }
  ],
  "Y+hV8Q": [
    {
      "type": 0,
      "value": "Torsdag (2024-11-08) kl. 16:30"
    }
  ],
  "Y294VV": [
    {
      "type": 0,
      "value": "Settings"
    }
  ],
  "YWqIuX": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Beställaren"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder en person som är minst 18 år och som har ansvar för hästen som den Sjukvårdande behandlingen avser vid Inskrivningen, antingen i egenskap av att själv vara Hästägare eller enligt fullmakt från Hästägaren."
    }
  ],
  "ZFx66U": [
    {
      "type": 0,
      "value": "Something went wrong"
    }
  ],
  "a8I10Q": [
    {
      "type": 0,
      "value": "Contact details"
    }
  ],
  "bXn7lI": [
    {
      "children": [
        {
          "type": 0,
          "value": "Profylaktisk behandling på initiativ av Djurägaren"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Evidensia ersätter inte skada till följd av profylaktisk behandling som utförts på initiativ av Djurägaren om Evidensia dessförinnan har avrått Djurägaren från behandlingen."
    }
  ],
  "beujhJ": [
    {
      "type": 0,
      "value": "Mobile BankID"
    }
  ],
  "cOcLsR": [
    {
      "type": 0,
      "value": "When your pet needs care, we’re here to help with anything."
    }
  ],
  "cPbREX": [
    {
      "type": 0,
      "value": "Please fill in the notes"
    }
  ],
  "cTqFgk": [
    {
      "type": 0,
      "value": "You must agree to the terms and conditions"
    }
  ],
  "d8n5n5": [
    {
      "children": [
        {
          "type": 0,
          "value": "”Sjukvårdande behandling” betyder"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " varje åtgärd som vidtas för att medicinskt förebygga, påvisa, lindra eller bota sjukdom, skada eller därmed jämförligt tillstånd hos djur; åtgärder för att utföra operativa ingrepp på eller ge injektioner till djur i annat fall; inklusive, men inte begränsat till, besiktningar av och utlåtanden om djurs status, hälsa eller därmed jämförbart tillstånd."
    }
  ],
  "dnPxQW": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Evidensia"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder det Dotterbolag inom Evidensia Djursjukvård AB, org. Nr 556880-7217, som utför den Sjukvårdande behandlingen."
    }
  ],
  "eR7nsN": [
    {
      "type": 0,
      "value": "Oops! This page does not exist."
    }
  ],
  "eYsKny": [
    {
      "children": [
        {
          "type": 0,
          "value": "Besiktning"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Om den Sjukvårdande behandlingen utgörs av besiktning av djurets status, hälsa eller därmed jämförbart tillstånd ska Evidensia i samband med Inskrivningen anteckna syftet med besiktningen. Syftet kommer vara avgörande för nivån och omfattningen av besiktningen. Djurägaren är medveten om att en besiktning alltid utgör en ögonblicksbedömning och en subjektiv värdering."
    }
  ],
  "fRA8IF": [
    {
      "type": 0,
      "value": "Insurance provider"
    }
  ],
  "gOPXE6": [
    {
      "type": 0,
      "value": "Book Clinic Visit"
    }
  ],
  "gclMyN": [
    {
      "type": 0,
      "value": "Contact information"
    }
  ],
  "ghblYR": [
    {
      "type": 0,
      "value": "Try Again!"
    }
  ],
  "iSyUA/": [
    {
      "type": 0,
      "value": "By accepting, you confirm that you have read and accept the terms"
    }
  ],
  "jA1SyB": [
    {
      "type": 0,
      "value": "Welcome"
    },
    {
      "type": 1,
      "value": "newLine"
    },
    {
      "type": 1,
      "value": "name"
    }
  ],
  "jXyZqz": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Kostnadstak"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder uppgift om den högsta kostnaden för den Sjukvårdande behandlingen som Evidensia, vid Hästägaren/Beställarens förfrågan, lämnar till Hästägaren/Beställaren i samband med Inskrivningen."
    }
  ],
  "k+3605": [
    {
      "type": 0,
      "value": "Hide details"
    }
  ],
  "kAqHc0": [
    {
      "type": 0,
      "value": "Nothing to do here! You have already accepted our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "terms and conditions"
        }
      ],
      "type": 8,
      "value": "tosLink"
    },
    {
      "type": 0,
      "value": " for your visit."
    }
  ],
  "kHCY5B": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Hästägaren"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder en person som är minst 18 år och som äger hästen som den Sjukvårdande behandlingen avser."
    }
  ],
  "lTcTd0": [
    {
      "type": 0,
      "value": "Try Again!"
    }
  ],
  "larG61": [
    {
      "type": 0,
      "value": "Welcome "
    },
    {
      "type": 1,
      "value": "name"
    }
  ],
  "m4dnTD": [
    {
      "type": 0,
      "value": "Something went wrong"
    }
  ],
  "mMWP1r": [
    {
      "type": 0,
      "value": "City"
    }
  ],
  "mcaPp/": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Inskrivning"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder det förfarande genom vilket Djurägaren registrerar sitt djur hos Evidensia i anslutning till den Sjukvårdande behandlingen. ”Kostnadsförslag” betyder en ungefärlig prisuppgift för den Sjukvårdande behandlingen som Evidensia lämnar till Djurägaren i samband med Inskrivningen."
    }
  ],
  "miQryU": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Evidensia"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder ett bolag (i) som direkt eller indirekt kontrollerar Evidensia; (ii) som är under samma direkta eller indirekta ägande eller kontroll som Evidensia; eller (iii) som direkt eller indirekt ägs eller kontrolleras av Evidensia. I det här sammanhanget ska ett bolag anses vara kontrollerat av någon annan om det andra bolaget äger mer än femtio procent (&gt;50%) av rösterna i ett sådant bolag, kan styra bolagets angelägenheter eller kontrollera styrelsens, eller motsvarande organs, sammansättning av styrelseledamöter eller motsvarande."
    }
  ],
  "mz0/QX": [
    {
      "type": 0,
      "value": "Try again"
    }
  ],
  "nCaFya": [
    {
      "type": 0,
      "value": "Before we can examine your animal or provide treatment, we need your approval of our terms. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Please read through below and approve"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " before your visit to us."
    }
  ],
  "o6MBsr": [
    {
      "type": 0,
      "value": "BankID on another device"
    }
  ],
  "oA+pjB": [
    {
      "children": [
        {
          "type": 0,
          "value": "E-post:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " please update your E-post address below"
    }
  ],
  "oKvvWS": [
    {
      "type": 0,
      "value": "Thank you for your acceptance! You can always access our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "terms and conditions"
        }
      ],
      "type": 8,
      "value": "tosLink"
    },
    {
      "type": 0,
      "value": " on our website."
    }
  ],
  "od7cXt": [
    {
      "type": 0,
      "value": "You can cancel your visit no later than 24 hours before. Missed visits will be charged."
    }
  ],
  "oeM2VM": [
    {
      "type": 0,
      "value": "Approval of General Terms for small animals"
    }
  ],
  "pQJao5": [
    {
      "type": 0,
      "value": "How can we help you?"
    }
  ],
  "pnF/9H": [
    {
      "type": 0,
      "value": "Something went wrong"
    }
  ],
  "qSSaPW": [
    {
      "type": 0,
      "value": "Zip code"
    }
  ],
  "qTE/PL": [
    {
      "type": 0,
      "value": "Name"
    }
  ],
  "qdUnYJ": [
    {
      "type": 0,
      "value": "years"
    }
  ],
  "qw1K8n": [
    {
      "type": 0,
      "value": "I AGREE"
    }
  ],
  "qzFV1H": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Kostnadstak"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder uppgift om den högsta kostnaden för den Sjukvårdande behandlingen som Evidensia, vid Djurägarens förfrågan, lämnar till Djurägaren i samband med Inskrivningen"
    }
  ],
  "r2vFkn": [
    {
      "children": [
        {
          "type": 0,
          "value": "Insurance number:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " please provide the insurance number"
    }
  ],
  "sNjwXV": [
    {
      "type": 0,
      "value": "Post code"
    }
  ],
  "tAIqPC": [
    {
      "type": 0,
      "value": "month"
    }
  ],
  "uFmv01": [
    {
      "type": 0,
      "value": "Something went wrong, please try again later."
    }
  ],
  "uRoKGW": [
    {
      "type": 0,
      "value": "Oops!"
    }
  ],
  "v2562G": [
    {
      "type": 0,
      "value": "Insurance details"
    }
  ],
  "wAgZ+4": [
    {
      "type": 0,
      "value": "(Mandatory)"
    }
  ],
  "wtJ+yD": [
    {
      "type": 0,
      "value": "Choose pet"
    }
  ],
  "xLTf+h": [
    {
      "type": 0,
      "value": "City"
    }
  ],
  "xyXEtx": [
    {
      "type": 0,
      "value": "Microchip"
    }
  ],
  "y2+tOy": [
    {
      "type": 1,
      "value": "label"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "value"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "ysoTKU": [
    {
      "type": 0,
      "value": "year"
    }
  ],
  "z0tayl": [
    {
      "type": 0,
      "value": "Species"
    }
  ],
  "z5tCw3": [
    {
      "type": 0,
      "value": "Something went wrong"
    }
  ],
  "zBFR3c": [
    {
      "children": [
        {
          "type": 0,
          "value": "Castrated:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Please indicate Yes or No."
    }
  ],
  "zDOf+o": [
    {
      "type": 0,
      "value": "Insurance No"
    }
  ],
  "zkaOOo": [
    {
      "type": 0,
      "value": "Your appointment is now booked. We look forward to seeing you and your pet soon."
    }
  ]
}
